import { Component, Input } from '@angular/core';

import { ShaftSealButton } from '../../models/shaft-seal-button.interface'

@Component({
  selector: 'shaft-seal-button',
  template: `
    <div>
      <p>{{ product.label }}</p>
      <a [href]="product.product_url" class="btn btn-template-primary btn-block pss-btn-top">
        #{{ product.part_number }}
      </a>
    </div>
  `
})

export class ShaftSealButtonComponent {
  @Input() product: ShaftSealButton;

  constructor() {}
}



// WEBPACK FOOTER //
// ./app/javascript/product_search/app/shaft-seal-product-selector/components/shaft-seal-button/shaft-seal-button.component.ts